// api
import { fetchApi } from '@/api'
// actions
const schoolRoutesMessengerAll = (context) => {
  let url = 'schoolroutes/messenger'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MESSENGER_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMessengerForm = (context) => {
  let url = 'schoolroutes/messenger/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MESSENGER_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMessengerShow = (context) => {
  let url = 'schoolroutes/messenger'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MESSENGER_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const schoolRoutesMessengerCreate = (context) => {
  let url = 'schoolroutes/messenger/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MESSENGER_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMessengerUpdate = (context) => {
  let url = 'schoolroutes/messenger'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTES_MESSENGER_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMessengerDelete = (context, payload) => {
  let url = 'schoolroutes/messenger'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTES_MESSENGER_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  schoolRoutesMessengerAll,
  schoolRoutesMessengerForm,
  schoolRoutesMessengerShow,
  schoolRoutesMessengerCreate,
  schoolRoutesMessengerUpdate,
  schoolRoutesMessengerDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/messenger/actions.js